import Theme from '@adsk/alloy-react-theme';

export const modalStyle = {
  maxWidth: '600px',
  width: '100%',
  maxHeight: '90vh',
  height: 'auto',
};

export const modalBodyStyle = {
  minHeight: '180px',
  paddingBottom: '40px',
};

export const fieldStyle = {
  paddingTop: '20px',
  width: '100%',
};

export const firstColumnFieldStyle = {
  padding: '20px 20px 0 0',
  width: '50%',
};

export const secondColumnFieldStyle = { paddingTop: '20px', width: '50%' };

export const flexWrapperStyle = { display: 'flex' };

export const secondColumnNoLabelFieldStyle = {
  paddingTop: '44px',
  width: '50%',
};

// Remove once the updated DateSelector component is available
export const customDateSelectorStyle = `
  display: flex;

  [data-testid="DateSelector__input-container"] {
    border: 1px solid ${Theme.colors.charcoal400};
    height: 36px;

    :hover {
      box-shadow: 0 0 0 2px ${Theme.colors.hoverHalo};
    }

    :focus {
      border: 1px solid ${Theme.colors.adskBlue500};
      box-shadow: 0 0 0 2px ${Theme.colors.focusHalo};
    }
  }

  [class*="SingleDateSelectedValue___StyledSpan"] {
    color: ${Theme.colors.charcoal900};
  }
`;

export const timezoneTooltipLinkStyle = {
  color: Theme.colors.white,
  textDecoration: 'none',
  ...Theme.typography.bodySmallBold,
};
